const RING = "ZERO FEES • 866ZEROFEES.COM • ";

export const RotatingLogo = ({ size = 160, ring = true, className = "", ringClass = "text-lime-300", testid = "rotating-logo" }) => (
  <div className={`relative ${className}`} style={{ width: size, height: size }} data-testid={testid}>
    {ring && (
      <svg viewBox="0 0 200 200" className={`spin-slow absolute -inset-[22%] h-[144%] w-[144%] ${ringClass}`} aria-hidden>
        <defs><path id={`ring-${testid}`} d="M100,100 m-84,0 a84,84 0 1,1 168,0 a84,84 0 1,1 -168,0" /></defs>
        <text className="font-mono" fontSize="12.5" fill="currentColor" textLength="522" lengthAdjust="spacing">
          <textPath href={`#ring-${testid}`}>{RING}</textPath>
        </text>
      </svg>
    )}
    <div className="absolute inset-0 rounded-full bg-lime-400/30 blur-2xl" />
    <div style={{ perspective: 900 }} className="absolute inset-0">
      <div className="coin h-full w-full">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="absolute inset-[1%] rounded-full bg-[#0B2A6F]" style={{ transform: `translateZ(${-i - 1}px)` }} />
        ))}
        <img src="/logo-mark.png" alt="866Zerofees.com" className="coin-face h-full w-full object-contain" draggable={false} />
        <img src="/logo-mark.png" alt="" className="coin-face coin-back h-full w-full object-contain" draggable={false} style={{ transform: "rotateY(180deg) translateZ(9px)" }} />
      </div>
    </div>
  </div>
);
